export default __webpack_public_path__ + "static/media/TrolleyPump.cfabefb6.jpg";